import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Force light theme only
  useEffect(() => {
    // Remove dark class if present
    document.documentElement.classList.remove('dark');
    localStorage.setItem('middleman_theme', 'light');
  }, []);

  const value = {
    theme: 'light',
    setTheme: () => {}, // No-op
    toggleTheme: () => {}, // No-op
    isDark: false,
    isLight: true,
    isLoading: false
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
